import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';

export default class TinyToothComponent extends Component {
    static propTypes = {
        color: PropTypes.string.isRequired,
        toothId: PropTypes.string.isRequired,
        toothData: PropTypes.array.isRequired
    };

    state = {
        color: 'blue',
        toothData: [],
        timeline: []
    };

    handleClearTooth = () => {
        this.setState({
            toothData: []
        });

        let rightShard = ReactDOM.findDOMNode(this.refs['rightShard']);
        let topShard = ReactDOM.findDOMNode(this.refs['topShard']);
        let bottomShard = ReactDOM.findDOMNode(this.refs['bottomShard']);
        let leftShard = ReactDOM.findDOMNode(this.refs['leftShard']);
        let middleShard = ReactDOM.findDOMNode(this.refs['middleShard']);

        rightShard.style.fill = null;
        topShard.style.fill = null;
        bottomShard.style.fill = null;
        leftShard.style.fill = null;
        middleShard.style.fill = null;
    };

    mapExistingFills = () => {
        if (! this.state.toothData) {
            this.handleClearTooth();

            return false;
        }

        if (this.state.toothData.fills.length <= 0) {
            this.handleClearTooth();

            return false;
        }

        this.state.toothData.fills.forEach((item, i) => {
            let shard = ReactDOM.findDOMNode(this.refs[item.shard_id]);
            shard.style.fill = this.state.toothData.color;
        });
    };

    handleShowHistory = (e) => {

        let timeline = [];
        for (let fill of this.props.selectedChart.fills) {
            if (fill.tooth_id !== this.props.toothId) {
                continue;
            }

            timeline.push(fill);
        }

        this.props.openTimelineModal(timeline, this.props.toothId);
    };

    handleOpenModal = (e) => {
        this.props.openModal(e, this.props.toothId);
    };

    componentDidMount() {
        let index = this.props.toothData.findIndex((item) => {
            return item.tooth_id === this.props.toothId
        });

        if (index >= 0) {
            this.setState({
                color: this.props.color,
                toothData: this.props.toothData[index]
            }, () => {
                this.mapExistingFills();
            });
        } else {
            this.handleClearTooth();
        }
    }

    componentWillReceiveProps(nextProps) {
        this.handleClearTooth();

       let index = nextProps.toothData.findIndex((item) => {
            return item.tooth_id === nextProps.toothId
        });

        if (index >= 0) {
            this.setState({
                color: nextProps.color,
                toothData: nextProps.toothData[index]
            }, () => {
                this.mapExistingFills();
            });
        } else {
            this.handleClearTooth();
        }
    }


    render() {
        let procedure = this.state.toothData.procedure_abbr;

        return (
            <div id={this.props.toothId}>
                <div className="text-center procedureGiven" style={{minHeight: '19px', cursor: (typeof procedure !== 'undefined' ? 'pointer' : 'default')}}
                     onClick={typeof procedure !== 'undefined' ? this.handleShowHistory : null}>

                    {procedure}
                </div>

                <svg viewBox="0 0 11738000 11737976" onClick={this.handleOpenModal}>
                    <g id="Layer_x0020_1">
                        <metadata id="CorelCorpID_0Corel-Layer"/>
                        <g id="_720061432">
                            <circle className="fil1 str0" cx="5868998" cy="5868990" r="5551194"/>
                            <path className="fil1 str1" ref="topShard" d="M5868964 317803c1532974,0 2920806,621310 3925317,1625916l-1975821 1975822c-498914,-498914 -1188128,-807504 -1949424,-807504 -761319,0 -1450581,308590 -1949495,807504l-1975822 -1975822c1004559,-1004559 2392343,-1625916 3925245,-1625916z"/>
                            <path className="fil1 str2" ref="leftShard" d="M1943719 1943719l1975870 1975870c-498891,498914 -807505,1188104 -807505,1949375 0,761320 308614,1450582 807505,1949472l-1975870 1975821c-1004606,-1004487 -1625916,-2392343 -1625916,-3925293 0,-1532902 621310,-2920686 1625916,-3925245z"/>
                            <path className="fil1 str3" ref="bottomShard" d="M7818460 7818436l1975821 1975821c-1004559,1004607 -2392343,1625916 -3925317,1625916 -1532902,0 -2920686,-621309 -3925245,-1625916l1975822 -1975821c498914,498914 1188176,807456 1949495,807456 761296,0 1450510,-308542 1949424,-807456z"/>
                            <path className="fil1 str4" ref="rightShard" d="M7818460 7818388l1975821 1975822c1004535,-1004559 1625916,-2392296 1625916,-3925198 0,-1532902 -621309,-2920734 -1625916,-3925293l-1975821 1975822c498890,498890 807504,1188104 807504,1949423 0,761320 -308662,1450534 -807504,1949424z"/>
                            <circle className="fil1 str5" ref="middleShard" cx="5869011" cy="5868976" r="2756925"/>
                        </g>
                    </g>
                </svg>
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/commons/Charting/TinyToothComponent.js
 **/